import {gsap} from "gsap";
import {Draggable} from "gsap/Draggable";
import {Observer} from "gsap/Observer";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";
import Lenis from "../lib/lenis/lenis.esm.js";

import PhotoSwipeLightbox from "../lib/photoswipe/photoswipe-lightbox.esm.min.js";
import PhotoSwipeDynamicCaption from "../lib/photoswipe/photoswipe-dynamic-caption-plugin.esm.js";
import PhotoSwipe from "../lib/photoswipe/photoswipe.esm.min.js";

gsap.registerPlugin(Draggable, Observer, ScrollTrigger, SplitText);

export {gsap};
export {Draggable};
export {Observer};
export {ScrollTrigger};
export {SplitText};
export {Lenis};
export {PhotoSwipeLightbox, PhotoSwipeDynamicCaption, PhotoSwipe};


